export enum VerificationStateEnum {
  CERTIFICATION_ERROR = 'CERTIFICATION_ERROR',
  WHITE_PERSON = 'WHITE_PERSON',
  OTHERS = 'OTHERS',
  SCAM = 'SCAM'
}
